var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3648 15.3648H0.633789V1.61579H3.39679V0.633789H4.31679V1.61579H11.6828V0.633789H12.6028V1.61579H15.3648V15.3648ZM1.55579 5.54379V14.3828H14.4448V5.54379H1.55579ZM1.55579 2.59779V4.56179H14.4448V2.59779H12.6028V3.57979H11.6828V2.59779H4.31679V3.57979H3.39679V2.59779H1.55579ZM9.84079 13.3978H8.92079V12.4158H9.84079V13.3968V13.3978ZM7.07879 13.3978H6.15979V12.4158H7.07879V13.3968V13.3978ZM4.31679 13.3978H3.39679V12.4158H4.31679V13.3968V13.3978ZM12.6028 11.4338H11.6828V10.4538H12.6028V11.4338ZM9.84079 11.4338H8.92079V10.4538H9.84079V11.4338ZM7.07879 11.4338H6.15979V10.4538H7.07879V11.4338ZM4.31679 11.4338H3.39679V10.4538H4.31679V11.4338ZM12.6028 9.47079H11.6828V8.49079H12.6028V9.47279V9.47079ZM9.84079 9.47079H8.92079V8.49079H9.84079V9.47279V9.47079ZM7.07879 9.47079H6.15979V8.49079H7.07879V9.47279V9.47079ZM4.31679 9.47079H3.39679V8.49079H4.31679V9.47279V9.47079ZM12.6028 7.50579H11.6828V6.52679H12.6028V7.50779V7.50579ZM9.84079 7.50579H8.92079V6.52679H9.84079V7.50779V7.50579ZM7.07879 7.50579H6.15979V6.52679H7.07879V7.50779V7.50579Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar-black.f79949d3.svg";
export { ForwardRef as ReactComponent };